<template>
  <div class="m-10" style="height:70%">
    <vue-scroll :ops="scrollBar">
      <div>
        <b-table
          :items="reviews"
          :fields="reviewFields"
          :per-page="pagination.pageLimit"
        >
          <template #head()="data">
            <span
              ><strong>{{ data.label }} ({{ pagination.total }})</strong></span
            >
          </template>
          <template v-slot:cell(reviews)="data">
            <b-row>
              <b-col cols="8">
                <a href="#" class="rider">{{
                  data.item.reviews.rider.firstName +
                    " " +
                    data.item.reviews.rider.lastName
                }}</a
                ><br />
                <a href="#" class="trip"
                  >Trip: {{ data.item.reviews.booking }}</a
                ><br />
                <h6>{{ data.item.reviews.comment }}</h6>
              </b-col>
              <b-col cols="3" align="right">
                <star-rating
                  id="ratings"
                  :star-size="10"
                  :inline="true"
                  :round-start-rating="false"
                  :read-only="true"
                  :border-width="2"
                  :max-rating="5.0"
                  :rating="
                    typeof data.item.reviews.rating !== `undefined`
                      ? parseFloat(data.item.reviews.rating.toFixed(1))
                      : 0
                  "
                />
              </b-col>
            </b-row>
          </template>
        </b-table>
      </div>
    </vue-scroll>
    <b-row>
      <b-col cols="2" md="4" class="my-1">
        <b-form-group
          label="Per page"
          label-cols-lg="5"
          label-size="sm"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            v-model="pagination.pageLimit"
            id="perPageSelect"
            size="sm"
            :options="[10, 30, 50]"
            @input="pageLimitChange"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col cols="7" md="6">
        <b-pagination
          v-model="pagination.page"
          :total-rows="pagination.total"
          :per-page="pagination.pageLimit"
          @change="changePage"
          size="sm"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import shebahApi from "@/services/shebah/index";
import StarRating from "vue-star-rating";

export default {
  name: "driverReviews",
  components: {
    StarRating
  },
  computed: {
    scrollBar() {
      return this.$store.getters["general/scrollbar"];
    }
  },
  watch: {},
  props: {
    driverId: String,
    driverRating: Number
  },
  data() {
    return {
      reviews: [],
      reviewFields: [
        {
          key: "reviews"
        }
      ],
      pagination: {
        page: 1,
        pageLimit: 10
      }
    };
  },
  async created() {
    this.getReviews();
  },
  methods: {
    changePage(pageNumber) {
      this.pagination.page = pageNumber;
      this.getReviews();
    },
    pageLimitChange(val) {
      this.changePage(1);
    },
    async getReviews() {
      let reviews = await shebahApi.api.drivers.reviews(
        this.driverId,
        this.pagination.page,
        this.pagination.pageLimit
      );
      this.reviews = this.reviewFactory(reviews.data);
      this.pagination = {
        pageCount: reviews.pageCount,
        total: reviews.total,
        page: reviews.page,
        pageLimit: reviews.pageLimit
      };
    },
    reviewFactory(reviews) {
      let newReviews = [];
      for (let review of reviews) {
        newReviews.push({
          reviews: review
        });
      }
      return newReviews;
    }
  }
};
</script>
<style lang="scss">
a.trip:link {
  color: gray;
  text-decoration: none;
  font-size: 12px;
}
a.trip:visited {
  color: gray;
  text-decoration: none;
}
a.trip:hover {
  text-decoration: underline;
}
a.rider:link {
  color: gray;
  text-decoration: none;
  font-size: 13px;
  font-weight: bold;
}
a.rider:visited {
  color: gray;
  text-decoration: none;
}
a.rider:hover {
  text-decoration: underline;
}
</style>>